"use client";


import { Link } from "@/i18n/navigation";
import type { ReplayPlayerMetrics } from "@/entities/replay-metrics";
import { Avatar, AvatarFallback, AvatarImage } from "@/shared/ui/data-display/avatar";

/**
 * KAN-743: подпись игрока в витринах метрик.
 *
 * Одна на все витрины эпика KAN-719, потому что расхождение здесь и было багом: топы по
 * поведению подписывали игрока Riot-ником, а таблица перформанса прямо над ними — именем
 * профиля с аватаром. Один человек в двух соседних блоках назывался по-разному, и в топах
 * его нельзя было открыть.
 *
 * Игрок без профиля остаётся с Riot-ником и БЕЗ ссылки: вести некуда, а «мёртвая» ссылка
 * читается как баг. Это не «данные не подтянулись» — человека на сайте просто нет.
 */
export function MetricsPlayerLabel({
  player,
  showAvatar = true,
}: {
  player: Pick<ReplayPlayerMetrics, "userId" | "displayName" | "riotIdGameName" | "avatarUrl">;
  showAvatar?: boolean;
}) {
  const name = player.displayName ?? player.riotIdGameName ?? "—";

  const body = (
    <span className="flex min-w-0 items-center gap-1.5">
      {showAvatar && player.userId ? (
        <Avatar className="h-5 w-5 shrink-0">
          <AvatarImage src={player.avatarUrl ?? undefined} alt={name} />
          <AvatarFallback className="bg-muted text-[10px]">
            {name.charAt(0).toUpperCase()}
          </AvatarFallback>
        </Avatar>
      ) : null}
      <span className="truncate">{name}</span>
    </span>
  );

  if (!player.userId) return body;

  return (
    <Link
      href={`/u/${player.userId}`}
      className="min-w-0 transition-colors hover:text-primary"
    >
      {body}
    </Link>
  );
}
